import { Component, OnInit,Input,SecurityContext } from '@angular/core';
import { environment } from '../../../environments/environment';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';

import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer} from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { DetalleUsuarioService } from 'src/app/Services/detalle-usuario.service';
import { FormBuilder, FormGroup } from '@angular/forms';
 

declare let gtag: Function;

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['cu.css', 'cu.min.css']

})
 
//
export class InicioComponent implements OnInit {

  @Input() rut: string;
  result:any;
  result3:any;
  dataLayer: any;
  private funcxrut = environment.funcxrut;
  private urllogin = environment.urllogin;
  form: FormGroup;
  // cod ambiente
  
  code : string;
  state: string;
  estado: string;

  constructor(private fb: FormBuilder, private http: HttpClient, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router,private sanitizer:DomSanitizer, public detalleUsuario:DetalleUsuarioService) {
    this.form = this.fb.group({
      user: [],
      pass: []
    });
   
  }

  ngOnInit() {
  }

  loginAccion(){
    const user = this.form.get('user').value;//
    const pass = this.form.get('pass').value;//
    const loginuser = new Promise<{nombreMensaje: string, rutPromesa: number}>((resolve, reject) => {
      //console.log("promesa 2");
      
      //console.log("promesa 1 "+this.detalleUsuario.obtenerRut()+"/"+rutPromesa);
      //let respuesta:String;
      let url2 = `${ this.urllogin}`;
      this.http.post<any>(url2, { 
        usuarioad:user,
        pass:pass
      },{ observe: 'response' }).subscribe((response: HttpResponse<any>) => {
        const status = response.status;
        const data = response.body;
        
        if (status===200) { 
          this.detalleUsuario.guardarRut(data.Resultado);
          this.detalleUsuario.actualizarVariable(data.Resultado);
          const rutPromesa = data.Resultado;
          let cadena = user;
          let partes = cadena.split('.');
          this.detalleUsuario.guardarNombre(partes[0].toLowerCase());
          this.detalleUsuario.guardarApellidoP(partes[1].toLowerCase());
          const nombreMensaje = partes[0].charAt(0).toUpperCase() + partes[0].slice(1) + " " + partes[1].charAt(0).toUpperCase() + partes[1].slice(1);
          resolve({nombreMensaje,rutPromesa});
        }else{
          //this.toastr.error(data.Resultado);
          console.log(data.Resultado);
          reject(data.Resultado);
        }
      }, err => {
        console.log("error capturado");
        console.log(err);
        if (err.error.Resultado.startsWith("Error")) {
          reject(err.error.Resultado.split('.')[0]);
        }
        reject(err);
      });
    });
      
    const validuser = (rutPromesa: number,nombreMensaje: string): Promise<string> => { 
      return new Promise<string>((resolve, reject) => {
        //console.log("promesa 2 " + nombreMensaje);
        /*let url2 = `${this.funcxrut}`;
        this.http.post<any>(url2, {
          rut: rutPromesa
        }, { observe: 'response' }).subscribe((response: HttpResponse<any>) => {
          const status = response.status;
          const data = response.body;
          if (status === 200) {
            this.detalleUsuario.actualizarFuncionalidadesJson(data.Resultado);
            //this.router.navigate(['/primer']);
            //this.toastr.info("Bienvenido "+ partes[0].charAt(0).toUpperCase() + partes[0].slice(1) + " " + partes[1].charAt(0).toUpperCase() + partes[1].slice(1) + ".");
            resolve(nombreMensaje);
          } else {
            //this.toastr.error(data.Resultado);
            console.log(data.Resultado);
            reject(data.Resultado);
          }
        }, err => {
          console.log("error capturado");
          console.log(err);
          reject("Usuario sin privilegios");
        });*/
        resolve(nombreMensaje);
      });
      
    }

    loginuser.then(({ nombreMensaje, rutPromesa }) => {
      console.log("Login exitoso:", nombreMensaje+", "+rutPromesa);
      return validuser(rutPromesa, nombreMensaje); // Retornar la promesa validuser
    })
    .then((resultadoValidacion) => {
      console.log("Validación exitosa:", resultadoValidacion);
      // Puedes manejar aquí la lógica posterior a validuser
      this.router.navigate(['/primer']);
      this.toastr.info("Bienvenido "+ resultadoValidacion + ".");
    })
    .catch((error) => {
      console.error("Ocurrió un error:", error);
      this.toastr.error("Error al ingresar: "+error +".");
    });
  }
}
